import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAudio } from "../Contexts/AudiosContext";
import imgdownload from "../assets/audioPlayer/img/download.svg";
import imgrepeatOn from "../assets/audioPlayer/img/repeatON.svg";
import imgrepeatOff from "../assets/audioPlayer/img/repeatOFF.svg";
import imgback from "../assets/audioPlayer/img/whiteprevious.svg";
import imgforward from "../assets/audioPlayer/img/whitenext.svg";
import imginfo from "../assets/audioPlayer/img/info.svg";
import imgclose from "../assets/audioPlayer/img/whitecancel.svg";
import imgmaximize from "../assets/img/max.png";
import imgpause from "../assets/audioPlayer/img/Pause.svg";
import imgplay from "../assets/audioPlayer/img/bgorangepause.svg";
import volumeIcon from "../Images/volume_up.svg";
import muteIcon from "../Images/volume_off.svg"
import "../Styles/Audios.css";
import { ProgressBar } from "react-bootstrap";
import { Alert, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import Favadd from "../assets/img/Like -Fill 1.svg";
import Favicon from "../assets/img/Like-Stroke 1.svg";
import sharePrimary from "../svg/sharePrimary.svg";
import AudiosService from "../Services/Audios";
import { AudioInfoDialog } from "../Pages/AudioInfoDialog";
import { copyShareUrl } from "../utils/copyShareUrl";
import { useVideo } from "../Contexts/VideosContext";
import {
  clearAudioInterrupt,
  getAudioResumeDelayMs,
  pauseAudioForVideo,
  pauseVideoForAudio,
  resumeAudioAfterVideo,
} from "../utils/mediaMutex";

const LogInModel = React.lazy(() =>
  import("../Pages/LoginModel").then((module) => ({ default: module.LogInModel }))
);

const AudioPlayer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const {
    isMin,
    setMin,
    currentAudio,
    isMinimise,
    setIsMinismise,
    close,
    next,
    prev,
    isLiked,
    favaddremove,
    playingAudio,
    setPlayingAudio,
    playVideo,
    setPlayVideo,
    refAudio,
  } = useAudio();
  const {
    playingVideo,
    setPlayingVideo,
    playerRef,
    setActiveMedia,
  } = useVideo();

  const [cTime, setCTime] = useState(0);
  const [aLength, setALength] = useState(0);

  const [audioinfoDialog, setAudioinfoDialog] = useState(false);
  const [downloadTrue, setDownloadTrue] = useState<boolean>(false)
  const [currentAudioId, setCurrentAudioId] = useState(currentAudio?.id);
  // Login required for download and favourite (play works for guests)
  const [logIn, setLogIn] = useState<boolean>(false);
  const [linkCopiedSnack, setLinkCopiedSnack] = useState(false);

  const isLoggedIn = () =>
    !!(localStorage.getItem("Token") && localStorage.getItem("UserId"));

  /** Copy currently playing track URL (type + slug), not the page under the bar. */
  const handleShareClick = async () => {
    const logdetails: string[] = [];
    logdetails.push("action=share_toolbar");
    const audioType = localStorage.getItem("type") || "audios";
    const slug = currentAudio?.slug;
    logdetails.push(`type=${audioType}`);
    logdetails.push(`slug=${slug || "none"}`);
    if (!slug) {
      logdetails.push("result=missing_slug");
      console.log("AudioPlayer -> handleShareClick ->", logdetails.join(" | "));
      return;
    }
    const url = `${window.location.origin}/${audioType}/${encodeURIComponent(slug)}`;
    const ok = await copyShareUrl(url);
    logdetails.push(`copied=${ok}`);
    console.log("AudioPlayer -> handleShareClick ->", logdetails.join(" | "));
    if (ok) setLinkCopiedSnack(true);
  };

  const closeLoginModal = () => {
    setLogIn(false);
  };

  const handleLoginStateChange = (newState: any) => {
    console.log("AudioPlayer -> handleLoginStateChange -> loggedIn:", newState);
    if (newState === true) {
      setLogIn(false);
    }
  };

  const [volume, setVolume] = useState(() => {
    const saved = localStorage.getItem("audioVolume");
    return saved ? parseFloat(saved) : 0.8;
  });

  const [isMuted, setIsMuted] = useState(false); // Mute state

  const [prevVolume, setPrevVolume] = useState(0.5); // Store volume before mute

  const handleVolumeChange = (e: any) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    localStorage.setItem("audioVolume", newVolume.toString());
    if (refAudio.current) {
      refAudio.current.volume = newVolume;
    }
  };

  const toggleMute = () => {
    if (isMuted) {
      // Unmute and restore previous volume
      setVolume(prevVolume);
      if (refAudio.current) {
        refAudio.current.volume = prevVolume;
      }
      setIsMuted(false);
    } else {
      // Mute and save current volume
      setPrevVolume(volume);
      setVolume(0);
      if (refAudio.current) {
        refAudio.current.volume = 0;
      }
      setIsMuted(true);
    }
  }

  const closeInfoModel = () => {
    setAudioinfoDialog(false)
  }

  function formatCurrentTime(seconds: any) {
    var hours: any = Math.floor(seconds / 3600);
    var minutes: any = Math.floor((seconds % 3600) / 60);
    var remainingSeconds: any = Math.floor(seconds % 60);
    if (remainingSeconds < 10) {
      remainingSeconds = "0" + remainingSeconds;
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    return hours + ":" + minutes + ":" + remainingSeconds;
  }

  function formatLastMinuteAndSecond() {
    var hours: any = Math.floor(aLength / 3600);
    var lastMinute: any = Math.floor((aLength % 3600) / 60);;
    var lastSeconds: any = Math.floor(aLength % 60);
    if (lastSeconds < 10) {
      lastSeconds = "0" + lastSeconds;
    }
    if (lastMinute < 10) {
      lastMinute = "0" + lastMinute;
    }
    return hours + ":" + lastMinute + ":" + lastSeconds;
  }

  function onLoadedMetadata(event: any) {
    setALength(event.target.duration);
  }

  const audioId = currentAudio?.id as any

  const setAudioInfoDialog = () => {
    if (audioinfoDialog) {
      setAudioinfoDialog(false);
    } else {
      setAudioinfoDialog(true);
    }
  };

  const [isRepeating, setIsRepeating] = useState(false);

  const repeataudio = () => {
    setIsRepeating(!isRepeating);
  };

  const downloadAudio = (imagePath: any) => {
    const imageUrl = imagePath;
    const link = document.createElement('a');
    link.href = imageUrl; link.download = 'image.jpg';
    document.body.appendChild(link); link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    // Update volume when isMuted changes (floating bar mute only)
    if (refAudio.current) {
      refAudio.current.muted = isMuted;
    }
  }, [isMuted, refAudio]);

  useEffect(() => {
    if (audioId !== currentAudioId) {
      setDownloadTrue(false);
      setCurrentAudioId(audioId);
    }
  }, [audioId, currentAudioId]);

  // Pause audio when a video starts; auto-resume when that video stops.
  // Brief YouTube seek pauses and inline↔PiP handoff are ignored via delay.
  useEffect(() => {
    if (playingVideo) {
      pauseAudioForVideo({
        refAudio,
        setPlayingAudio,
        setActiveMedia,
      });
      return;
    }

    const delayMs = getAudioResumeDelayMs(600);
    const timer = window.setTimeout(() => {
      resumeAudioAfterVideo({
        refAudio,
        setPlayingAudio,
        setActiveMedia,
      });
    }, delayMs);

    return () => window.clearTimeout(timer);
  }, [playingVideo, refAudio, setPlayingAudio, setActiveMedia]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1280);
  // Inner controls match .containers width; the orange bar itself is full page width
  const [playerLayout, setPlayerLayout] = useState<{ left?: number; width?: number }>({});

  useEffect(() => {
    const syncMiniPlayerToCenter = () => {
      const logdetails: string[] = [];
      logdetails.push("action=sync_mini_player_inner_width");
      const mobile = window.innerWidth < 1280;
      setIsMobile(mobile);
      if (mobile) {
        setPlayerLayout({});
        logdetails.push("viewport=mobile width=100%");
        console.log("AudioPlayer -> syncMiniPlayerToCenter ->", logdetails.join(" | "));
        return;
      }
      const el = document.querySelector(".containers") as HTMLElement | null;
      if (el) {
        const rect = el.getBoundingClientRect();
        setPlayerLayout({
          left: Math.round(rect.left),
          width: Math.round(rect.width),
        });
        logdetails.push(`source=containers left=${Math.round(rect.left)} width=${Math.round(rect.width)}`);
      } else {
        setPlayerLayout({});
        logdetails.push("source=css_fallback");
      }
      console.log("AudioPlayer -> syncMiniPlayerToCenter ->", logdetails.join(" | "));
    };

    syncMiniPlayerToCenter();
    window.addEventListener("resize", syncMiniPlayerToCenter);
    const el = document.querySelector(".containers");
    const ro = el && typeof ResizeObserver !== "undefined" ? new ResizeObserver(syncMiniPlayerToCenter) : null;
    if (el && ro) ro.observe(el);
    return () => {
      window.removeEventListener("resize", syncMiniPlayerToCenter);
      ro?.disconnect();
    };
  }, [location.pathname]);

  return (
    <div>
      {/* Keep <audio> outside display:none UI — browsers block play() on hidden media.
          Do NOT bind muted as a React controlled prop; page + bar set it imperatively
          so volume/mute controls are not overwritten on every re-render. */}
      {currentAudio?.id ? (
        <audio
          ref={refAudio}
          id={`audio-${currentAudio.id}`}
          autoPlay={true}
          loop={isRepeating}
          src={
            currentAudio.audioUrl != null
              ? currentAudio.audioUrl
              : currentAudio.pravachanUrl
          }
          onPlay={() => {
            const logdetails: string[] = [];
            logdetails.push("action=audio_onPlay");
            logdetails.push(`audio_id=${currentAudio.id}`);
            console.log("AudioPlayer -> audio element ->", logdetails.join(" | "));

            // Audio started last — stop any running video (inline or PiP)
            pauseVideoForAudio({
              playerRef,
              setPlayingVideo,
              setActiveMedia,
            });
            setPlayingAudio(true);
          }}
          onPause={() => {
            const logdetails: string[] = [];
            logdetails.push("action=audio_onPause");
            logdetails.push(`audio_id=${currentAudio.id}`);
            console.log("AudioPlayer -> audio element ->", logdetails.join(" | "));
            setPlayingAudio(false);
          }}
          onDurationChange={(e) => {
            setALength(e.currentTarget.duration);
          }}
          onLoadedMetadata={onLoadedMetadata}
          onTimeUpdate={(e) => {
            setCTime(e.currentTarget.currentTime);
            if (
              e.currentTarget.duration === e.currentTarget.currentTime
            ) {
              next();
            }
          }}
        />
      ) : null}

      {currentAudio?.id ? (
        <div
          className="playaudio backcolor music-player"
          style={{
            color: "white",
            fontSize: "16px",
            /* Hide universal floating bar on full audio player page (isMinimise=false) */
            display: !isMinimise ? "none" : (!isMobile ? "flex" : ""),
            pointerEvents: !isMinimise ? "none" : "auto",
            justifyContent: "center",
            alignItems: "center",
          }}
          title={currentAudio?.name}
        >
          <div
            className="music-player-inner"
            style={
              playerLayout.width
                ? { width: playerLayout.width }
                : undefined
            }
          >
          <div className="column music-player-title" style={{ display: !isMobile ? "flex" : "none" }}>
            <div style={{ minWidth: 0, width: "100%" }}>
                <div className="music-player-title-text" style={{ fontSize: "20px", cursor: "pointer"}} onClick={() => {
                  isMinimise && navigate(
                    `/${localStorage.getItem("type")}/` + currentAudio?.slug || `/${localStorage.getItem("type")}/` + currentAudio?.id,
                    {
                      state: { audioId: currentAudio?.id },
                    }
                  );
                }}>
                  {/* {currentAudio?.name} */}
                  {currentAudio?.name != null && currentAudio.name.length > 40
                    ? currentAudio.name.slice(0, 40) + "..."
                    : currentAudio?.name + "..."}
                </div>
            </div>
          </div>
          <div className="music-player-center">
          <div className="music-player-controls">
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                setAudioInfoDialog();
              }}
            >
              <img
                alt="imginfo"
                src={imginfo}
                title="information"
                width="30px"
              />
            </button>
          </div>
          <div className="column">
            <button
              disabled={downloadTrue}
              className="backcolor"
              id="download"
              title="Download"
              onClick={() => {
                // Download requires login
                if (!isLoggedIn()) {
                  console.log("AudioPlayer -> download blocked — opening login modal");
                  setLogIn(true);
                  return;
                }
                setDownloadTrue(true)
                downloadAudio(currentAudio != null
                  ? currentAudio.audioPath != null
                    ? currentAudio.audioPath + "&download_attachment=true"
                    : currentAudio.pravachanPath + "&download_attachment=true"
                  : "no record found")
              }}>
              <img
                alt="imgdownload"
                src={imgdownload}
                title="download"
                width="30px"
              />
            </button>
          </div>
          <div className="column">
            <button
              className="backcolor"
              title={t("Share_tr") || "Share"}
              aria-label={t("Share_tr") || "Share"}
              onClick={() => { void handleShareClick(); }}
            >
              <img
                alt="share"
                className="music-player-share-icon"
                src={sharePrimary}
                title={t("Share_tr") || "Share"}
                width="30px"
              />
            </button>
          </div>
          <label
            onClick={() => {
              // Favourite requires login; status loads only when logged in via context
              if (!isLoggedIn()) {
                console.log("AudioPlayer -> favourite blocked — opening login modal");
                setLogIn(true);
                return;
              }
              favaddremove();
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              src={isLiked ? Favadd : Favicon}
              alt="Favicon"
            />
          </label>
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                repeataudio();
              }}
            >
              <img
                alt="imgrepeat"
                src={isRepeating ? imgrepeatOn : imgrepeatOff}
                title="repeat"
                width="30px"
              />
            </button>
          </div>

          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                prev();
                setDownloadTrue(false)
              }}
            >
              <img alt="imgback" src={imgback} title="prev" width="30px" />
            </button>
          </div>

          <div className="column music-player-play">

            {playingAudio ? (
              <button
                className="backcolor"
                onClick={() => {
                  // User paused audio themselves — do not auto-restart after video.
                  clearAudioInterrupt();
                  refAudio.current?.pause();
                }}
              >
                <img alt="imgPse" src={imgpause} title="pause" width="40px" />
              </button>
            ) : (
              <button
                className="backcolor"
                onClick={() => {
                  // User clicked audio play — stop video first
                  pauseVideoForAudio({
                    playerRef,
                    setPlayingVideo,
                    setActiveMedia,
                  });
                  refAudio.current?.play();
                }}
              >
                <img alt="imgPse" src={imgplay} title="play" width="40px" />
              </button>
            )}
          </div>
          <div className="column">
            <button
              className="backcolor"
              onClick={() => {
                next();
                setDownloadTrue(false)
              }}
            >
              <img
                alt="imgforward"
                src={imgforward}
                title="next"
                width="30px"
              />
            </button>
          </div>
          </div>

          <div className="column music-player-time">
            <span id="time">{formatCurrentTime(cTime)}</span>
          </div>
          <div
            className="column music-player-progress"
          >
            <ProgressBar
              variant="white"
              color="orange"
              now={cTime}
              min={0}
              max={aLength}
              style={{
                height: "6px",
                backgroundColor: "#e48c02",
              }}
              onClick={(e: any) => {
                const rect = e.currentTarget.getBoundingClientRect();       // ✅ CHANGED
                const clickX = e.clientX - rect.left;                        // ✅ CHANGED
                const width = rect.width;                                   // ✅ CHANGED
                const newTime = (clickX / width) * aLength;                 // ✅ CHANGED
                if (refAudio.current) refAudio.current.currentTime = newTime;

                // var mouseX = e.clientX;
                // var barX = e.target.offsetLeft;
                // let distanceX = mouseX - barX;
                // let total = e.currentTarget.offsetWidth;
                // let timePerPixel = aLength / total;
                // let currentTime = distanceX * timePerPixel;
                // if (refAudio.current) refAudio.current.currentTime = currentTime;
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: `${(cTime / aLength) * 100}%`,
                transform: "translate(-50%, -50%)",
                width: "15px",                                   // 🟠 NEW
                height: "15px",                                  // 🟠 NEW
                borderRadius: "50%",                             // 🟠 NEW
                backgroundColor: "#fff",                         // 🟠 NEW
                border: "2px solid #e48c02",                     // 🟠 NEW
                zIndex: 2,                                       // 🟠 NEW
                transition: "left 0.1s linear",                  // 🟠 NEW
              }}
            ></div>
          </div>
          <div className="column music-player-time">
            <span id="total-time">{formatLastMinuteAndSecond()}</span>
          </div>
          </div>
          <div className="music-player-right">
          <div className="column music-player-volume">
            <div
              onClick={toggleMute} style={{ display: "flex", alignItems: "center" }}>
              {isMuted ? (
                <img src={muteIcon} alt="" />
              ) : (
                <img src={volumeIcon} alt="" />
              )}
            </div>
            <input
              id='volume-control'
              type='range'
              min='0'
              max='1'
              step='0.01'
              value={volume}
              onChange={handleVolumeChange}
              className="volume-slider"
            />
          </div>
          <div className="column music-player-actions"
            style={{ display: isMinimise ? "flex" : "none" }}
          >
            <button
              className="backcolor"
              // style={{display: isMinimise ? "block" : "none" }}
              onClick={() => {
                setIsMinismise(false);
                setMin(false)
                navigate(
                  `/${localStorage.getItem("type")}/` + currentAudio?.slug,
                  {
                    state: {
                      audioSlug: currentAudio?.slug,
                      audioId: currentAudio?.id
                    },
                  });
              }}
            >
              <img
                alt="imgmaximize"
                src={imgmaximize}
                title="maximize"
                width="30px"
              />
            </button>
          </div>

          <div
            className="column music-player-actions"
            style={{ display: isMinimise ? "flex" : "none" }}
          >
            <button
              className="backcolor"
              onClick={() => {
                clearAudioInterrupt();
                setPlayingAudio(false);
                close();
              }}
            >
              <img alt="imgclose" className="music-player-close-icon" src={imgclose} title="close" width="30px" />
            </button>
          </div>
          </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <AudioInfoDialog showModal={audioinfoDialog} onCloses={closeInfoModel} />
      {logIn && (
        <React.Suspense fallback={null}>
          <LogInModel
            opens={logIn}
            onCloses={closeLoginModal}
            onLoginStateChange={handleLoginStateChange}
          />
        </React.Suspense>
      )}
      <Snackbar
        open={linkCopiedSnack}
        autoHideDuration={2500}
        onClose={() => setLinkCopiedSnack(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        /* Sit above the 55px mini player (z-index 99999) so the toast is not clipped */
        sx={{
          "&.MuiSnackbar-root": {
            zIndex: 100000,
            bottom: "72px",
          },
        }}
      >
        <Alert onClose={() => setLinkCopiedSnack(false)} severity="success" sx={{ width: "100%" }}>
          {t("Link_copied_tr") || "Link copied"}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default AudioPlayer;
